import { render, staticRenderFns } from "./DashboardReconnectShopsWarning.vue?vue&type=template&id=097cee04&scoped=true"
import script from "./DashboardReconnectShopsWarning.vue?vue&type=script&lang=js"
export * from "./DashboardReconnectShopsWarning.vue?vue&type=script&lang=js"
import style0 from "./DashboardReconnectShopsWarning.vue?vue&type=style&index=0&id=097cee04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097cee04",
  null
  
)

export default component.exports